module.exports = __webpack_public_path__ + "img/686464_CCCAC7_A4A19F_BCB4B4-256px.ba9bc3d2.png";